<div class="aems-card m-b-12">
  <div class="pure-g">
    <div class="pure-u-md-24-24 p-b-16">
      <h3>Shop</h3>
    </div>
  </div>
  <div style="flex: 1; text-align: left; padding-left: 16px">
    <mc-textarea
      label="Enter shop codes manually to activate"
      placeholder="Enter shop codes separated by a new line"
      [rows]="5"
      (input)="onManualInput($event)">
      name="explanation">
    </mc-textarea>
  </div>
</div>
<app-button-with-confirmation
  label="Activate Shop"
  appearance="primary"
  variant="filled"
  [hiddenlabel]="false"
  modalBody="Are you sure you want to activate the shop?"
  modalHeading="Shop Activate"
  confirmButtonLabel="Yes, activate"
  cancelButtonLabel="No"
  [loading]="shopApiCallStatus === 'IN_PROGRESS'"
  [onConfirm]="onActivateClicked()">
</app-button-with-confirmation>
